import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
  InputAdornment,
  Card,
  CardContent,
  CardActions,
} from "@material-ui/core";
import jsPDF from "jspdf";
import InterFont from "../../../fonts/Inter.ttf";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import loanSolvLogo from "../../../images/logo/LoanSolveLogo.png";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Cropper from "react-easy-crop";
import axios from "axios";
import { toast } from "react-toastify";
import Notification from "../../../components/Notification";
import useStyles from "../../../themes/style";
import { useHistory, useLocation } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";
import getCroppedImg from "../../../utils/croppedImage";
import "../../../css/agreement-resume.css";
import moment from "moment";
import { getMuiTheme } from "../../../samples/style";
import { useNotification } from "../../../hooks/useNotification.js";
import { jwtDecode } from "jwt-decode";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { useEmployeeDetails } from "../../../context/EmployeeDataContext.js";

function SeparationTemplate() {
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const history = useHistory();
  const location = useLocation();
  const agreementfileRef = useRef(null);
  const handleNotificationCall = useNotification();
  const candidateId = new URLSearchParams(location.search).get("id");
  const { profileMenuName } = useEmployeeDetails();

  const [modalOpen, setModalOpen] = useState(true);
  const [hideActionBtns, setHideActionBtns] = useState(false);
  const [sendReleaving, setSendReleaving] = useState(false);
  const [releavingData, setReleavingData] = useState({
    name: "",
    releavingDate: "",
  });
  const [salaryBreakupData, setSalaryBreakupData] = useState({
    basic: 0,
    hra: 0,
    otherAllowance: 0,
    statutoryBonus: 0,
    shiftAllowance: 0,
    addEmployerPF: 0,
    addESI: 0,
    gratuity: 0,
    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalDeductions: 0,
    totalCTC: 0,
    totalGrossSalary: 0,
  });

  useEffect(() => {
    if (candidateId) {
      setModalOpen(true);
    }
    if (profileMenuName?.isSentReleave) {
      setSendReleaving(true);
    }
  }, []);

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .max(255)
      .required("Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Name Must be Alphanumeric",
      }),

    releavingDate: Yup.string().required("Resignation Date is required"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      basic: 0,
      otherAllowance: 0,
      shiftAllowance: 0,
      professionalTax: 0,
    },
  });

  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  const styles = {
    grandMasterContainer: {
      minWidth: "800px",
      minHeight: "1000px",
      margin: "auto",
      maxWidth: "800px",
    },
    masterContainer: {
      minWidth: "802px",
      minHeight: "1000px",
      maxWidth: "800px",
      margin: "40px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerTwo: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "60px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerThree: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "120px auto 0px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
    masterContainerFour: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "100px auto 0px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
  };

  function handleAddAgreement(values) {
    setReleavingData({ ...values });

    try {
      setModalOpen(false);
      // if (imageSrc) {
      //   let HRA = values.basic / 2;
      //   let stautoryBonus = Math.round(values.basic / 12);

      //   let totalGrossSalary =
      //     values.basic + HRA + values.otherAllowance + stautoryBonus;

      //   let addEmployerPF = Math.round(values.basic * 0.12);
      //   let totalCTC = totalGrossSalary+addEmployerPF;

      //   let employeePF = Math.round(values.basic * 0.12);
      //   let totalDeductions = employeePF + values.professionalTax;

      //   setSalaryBreakupData({
      //     basic: values.basic,
      //     hra: HRA,
      //     otherAllowance: values.otherAllowance,
      //     statutoryBonus: stautoryBonus,
      //     shiftAllowance: 0,
      //     addEmployerPF: addEmployerPF,
      //     addESI: 0,
      //     gratuity: 0,
      //     employeeESI: 0,
      //     employeePF: employeePF,
      //     professionalTax: values.professionalTax,

      //     totalGrossSalary: totalGrossSalary,
      //     totalCTC: totalCTC,
      //     totalDeductions: totalDeductions,
      //   });
      //   console.log(values);
      //   handleModalClose();
      // setCandidateRoleModal(false);
      // setCandidateDetails({ ...values });
      // } else {
      //   handleNotificationCall("info", "Please select signature");
      // }
    } catch (error) {
      console.log(error);
    }
  }

  const [loader, setLoader] = useState(false);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgae, setCroppedImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file && file?.size >= 2000000) {
        handleNotificationCall("info", "Maximum File Size Limit 2mb");
        return;
      }
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageSrc(reader.result));
      reader.readAsDataURL(file);
      setShowModal(true);
    }
  };

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(croppedImageBlob);
      reader.onloadend = () => {
        setCroppedImage(reader.result); // This will be a base64 data URL
      };
    },
    [imageSrc],
  );

  const handleUpload = async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    if (croppedImageBlob.size > 3 * 1024 * 1024) {
      alert("The cropped image size exceeds 3MB. Please crop again.");
      return;
    }
    setShowModal(false);
  };

  const handleGeneratePdf = async () => {
    setHideActionBtns(true);
    // if (!croppedImgae) {
    //   handleNotificationCall("info", " please Attach your Signature");
    //   setHideActionBtns(false);
    //   return;
    // }
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = agreementfileRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          handleAgreementSign(pdfBlob, doc);
          // doc.save(`Rel_${releavingData.name}_${Date.now()}.pdf`);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  const handleClearFormData = () => {
    reset();
    setImageSrc(null);
    setCroppedImage(null);
    handleModalOpen();
  };

  async function handleAgreementSign(pdfBlob, doc) {
    setLoader(true);
    const formData = new FormData();
    const releavingDate = releavingData.releavingDate;
    const sperationDocument = new File(
      [pdfBlob],
      `RelievingLetter_${releavingData.name}_${Date.now()}.pdf`,
    );
    formData.append("document", sperationDocument);
    formData.append("releavingDate", releavingDate);

    formData.forEach((item) => console.log(item));

    axios
      .post(
        `${process.env.REACT_APP_SERVER}employee/userSeperation`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      )
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          handleNotificationCall("success", response.data.message);
          doc.save(`RelievingLetter_${releavingData.name}_${Date.now()}.pdf`);
          window.location.reload();
        } else {
          setLoader(false);
          handleNotificationCall("error", response.data.message);
        }
      });

    // axios({
    //   method: "post",
    //   url: `${process.env.REACT_APP_SERVER}employee/userSeperation`,
    //   body:  formData,
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //     Authorization: token,
    //   },
    // }).then(function (response) {
    //   if (response.data.status === true) {
    //     setLoader(false);
    //     handleNotificationCall("success", response.data.message);
    //     doc.save(`Rel_${releavingData.name}_${Date.now()}.pdf`);
    //   } else {
    //     setLoader(false);
    //     handleNotificationCall("error", response.data.message);
    //   }
    // });
  }

  //   function fetchUserData() {
  //     setLoader(true);
  //     axios({
  //       method: "post",
  //       url: `${process.env.REACT_APP_SERVER}recruiter/viewUsers`,
  //       data: {
  //         id: decode.user_id,
  //       },
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: token,
  //       },
  //     })
  //       .then(function (response) {
  //         if (response.data.status === true) {
  //           const resposeData = response.data.data;
  //           if (resposeData && resposeData.recruiter?.nda) {
  //             history.push("/app/dashboard");
  //           }
  //         }
  //         setLoader(false);
  //       })
  //       .catch(function (error) {
  //         setLoader(false);
  //         console.log(error);
  //       });
  //   }

  useEffect(() => {
    // fetchUserData();
    // setModalOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Relieving Letter"/>
        </Grid>
      </Grid>
      {profileMenuName ? (
        profileMenuName?.isSentReleave ? (
          <Card
            sx={{
              maxWidth: 400, // Set the maximum width
              width: "90%", // Ensure responsiveness
              margin: "20px auto",
              boxShadow: 3,
            }}
            style={{ maxWidth: "500px", margin: "0 auto" }}
          >
            <CardContent>
              <h5
                style={{ fontSize: "20px", margin: "0", fontWeight: "normal",textAlign:"center" }}
                color="text.secondary"
              >
                Your Relieving is Accepted.
              </h5>
            </CardContent>
            <CardActions></CardActions>
          </Card>
        ) : (
          <MuiThemeProvider theme={getMuiTheme()}>
            <>
              <div
                className={classes.backgroundColor}
                style={{ overflow: "auto" }}
              >
                <div ref={agreementfileRef} style={styles.grandMasterContainer}>
                  <div style={styles.masterContainer}>
                    <table
                      style={{
                        fontSize: "12px",
                        lineHeight: "20px",
                        width: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <td style={{ textAlign: "center", margin: "0" }}>
                            <img
                              src={loanSolvLogo}
                              width="300"
                              alt="logo_company"
                              style={{ display: "block", margin: " 0 auto" }}
                            />
                          </td>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: "12pt" }}>
                        <tr>
                          <td
                            style={{
                              textAlign: "end",
                              color: "#000",
                              fontWeight: "500",
                              padding: "0 10px",
                              margin: "10px 0",
                            }}
                          >
                            <p>
                              Date:{" "}
                              {moment(new Date().toLocaleString()).format(
                                "Do MMMM YYYY",
                              )}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              textAlign: "justify",
                              color: "#000",
                              fontWeight: "500",
                              padding: "0 10px",
                              lineHeight: "1.5",
                              margin: "0",
                            }}
                          >
                            <p>
                              <b>Subject :</b> Submitting resignation from
                              service
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              textAlign: "left",
                              color: "#000",
                              fontWeight: "500",
                              padding: "0 10px",
                              margin: "0",
                            }}
                          >
                            <p>Dear {releavingData.name},</p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              textAlign: "justify",
                              color: "#000",
                              fontWeight: "500",
                              padding: "0 10px",
                              lineHeight: "1.7",
                              margin: "0",
                            }}
                          >
                            <p>
                              I would like to submit my resignation from service
                              due to personal reasons. Kindly accept my
                              resignation and relieve me on ,
                              {moment(releavingData.releavingDate).format(
                                "Do MMMM YYYY",
                              )}
                              <p style={{ height: "56px" }}></p>
                              <p style={{ margin: "8px 0px" }}>
                                <b>Regards</b>,
                              </p>
                              <p>{releavingData.name}</p>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                    margin: "0px 20px 20px 20px",
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleClearFormData}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    className={classes.green}
                    onClick={handleGeneratePdf}
                  >
                    Send
                  </Button>
                </div>
              </div>

              <Dialog
                aria-labelledby="dialog-title"
                open={modalOpen}
                width="sm"
                maxWidth="sm"
                PaperProps={{
                  style: {
                    width: "100%",
                  },
                }}
              >
                <DialogContent className={classes.center}>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    style={{
                      padding: "20px 10px",
                      overflow: "scroll",
                    }}
                  >
                    <div
                      className={classes.heading + " " + classes.inputRoot}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        width: "100%",
                      }}
                    >
                      <form onSubmit={handleSubmit(handleAddAgreement)}>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} lg={6}>
                            <InputLabel shrink htmlFor="employeeName">
                              Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                InputProps={{ disableUnderline: true }}
                                classes={{ root: classes.customTextField }}
                                size="small"
                                placeholder="Enter Your Name"
                                id="name"
                                error={errors.name ? true : false}
                                {...register("name")}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.name?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={6}>
                            <InputLabel shrink htmlFor="releavingDate">
                              Date
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="date"
                                InputProps={{ disableUnderline: true }}
                                classes={{ root: classes.customTextField }}
                                placeholder="Enter Date"
                                {...register("releavingDate")}
                                error={errors.releavingDate ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.releavingDate?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                        <div
                          style={{
                            margin: "10px 15px",
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                          }}
                        >
                          {/* <Button
                        variant="contained"
                        type="button"
                        size="small"
                        onClick={handleModalClose}
                      >
                        Close
                      </Button> */}
                          <Button
                            variant="contained"
                            type="submit"
                            size="small"
                            className={classes.green}
                          >
                            Submit
                          </Button>
                        </div>
                      </form>
                    </div>
                  </Grid>
                </DialogContent>
              </Dialog>

              <Dialog
                aria-labelledby="dialog-title"
                open={showModal}
                width="md"
                maxWidth="sm"
                PaperProps={{
                  style: {
                    width: "100%",
                  },
                }}
                onClose={() => setShowModal(false)}
              >
                <DialogContent>
                  <div
                    className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
                  >
                    <Typography
                      variant="subtitle2"
                      className={classes.inputRoot}
                    >
                      {" "}
                      Crop Image{" "}
                    </Typography>

                    <div className={classes.pdfModalCloseBtn}>
                      <CloseIcon className={classes.closeBtn} />
                    </div>
                  </div>
                  <div
                    className="d-flex"
                    style={{ position: "sticky", minHeight: "50vh" }}
                  >
                    {imageSrc && (
                      <div className="crop-container">
                        <Cropper
                          image={imageSrc}
                          crop={crop}
                          zoom={zoom}
                          aspect={16 / 9}
                          onCropChange={setCrop}
                          onCropComplete={onCropComplete}
                          onZoomChange={setZoom}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={classes.sendWhatsapp + " " + classes.inputRoot}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={() => {
                        setShowModal(false);
                        setCroppedImage(null);
                        setImageSrc(null);
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={handleUpload}
                    >
                      Crop
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>

              <ToastContainer
                closeButton={
                  <CloseButton className={classes.notificationCloseButton} />
                }
                closeOnClick={false}
                hideProgressBar={true}
              />
              <Backdrop className={classes.backdrop} open={loader}>
                <CircularProgress color="inherit" />
              </Backdrop>
            </>
          </MuiThemeProvider>
        )
      ) : (
        ""
      )}
    </div>
  );
}

export default SeparationTemplate;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
